// extracted by mini-css-extract-plugin
export default {"singleBentoContainer":"BentoCarouselSection-module__singleBentoContainer___2im2c"};